import { Button, ButtonProps, HStack, Icon, Text, Tooltip } from '@chakra-ui/react';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { fontWeights } from '../../global/Fonts';

interface NavButtonProps extends ButtonProps {
  icon?: ElementType;
  to: string;
  label: string;
  isCollapsed?: boolean;
}

export const NavButton = (props: NavButtonProps) => {
  const { t } = useTranslation();
  const { icon, to, label, isCollapsed = false, ...buttonProps } = props;
  const translatedLabel = t(`sidebar:${label}`);

  const button = (
    <Button
      as={NavLink}
      variant="unstyled"
      w={'full'}
      display={'block'}
      to={to}
      px={3}
      borderRadius="md"
      transition="none"
      fontFamily="body"
      fontWeight={fontWeights.normal}
      size={'md'}
      role="group"
      aria-label={isCollapsed ? translatedLabel : undefined}
      _activeLink={{
        bg: 'whiteAlpha.300',
        '& svg': {
          stroke: 'white',
        },
      }}
      _hover={{
        bg: 'whiteAlpha.400',
      }}
      {...buttonProps}
    >
      <HStack spacing="3" w={'full'} h={'full'}>
        <Icon as={icon} boxSize="6" transition="none" _groupHover={{ color: 'inverted' }} />
        {!isCollapsed && <Text as={'span'}>{translatedLabel}</Text>}
      </HStack>
    </Button>
  );

  if (!isCollapsed) {
    return button;
  }

  return (
    <Tooltip label={translatedLabel} placement="right" hasArrow openDelay={200}>
      {button}
    </Tooltip>
  );
};
